module.exports = __webpack_public_path__ + "img/vasyr-2018.aa875f19.jpg";